import { useState, useEffect, useRef } from 'react';
import { apiService, TaskStatusResponse } from '../services/api';

const POLL_INTERVAL = 2000; // 2 seconds

export function useTaskPolling(taskId: string, enabled: boolean = true) {
  const [status, setStatus] = useState<TaskStatusResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!enabled || !taskId) return;

    const pollStatus = async () => {
      try {
        const response = await apiService.getTaskStatus(taskId);
        setStatus(response);
        setIsLoading(false);
        setError(null);

        // 停止轮询如果任务完成或失败
        if (response.status === 'completed' || response.status === 'failed') {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to fetch status';
        setError(errorMessage);
        setIsLoading(false);
      }
    };

    // 立即执行一次
    pollStatus();

    // 设置轮询
    intervalRef.current = setInterval(pollStatus, POLL_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [taskId, enabled]);

  return { status, isLoading, error };
}
